module.exports = __webpack_public_path__ + "static/ProductDevelopment-banner-c12c0a2f2861ffc223399e05fe3b7a2b.png";